import React from 'react';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialogTitle } from '../styled/Dialog/StyledDialogTitle';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import StyledTitle from '../styled/Dialog/StyledTitle';
import usePdfDialog from 'hooks/usePdfDialog';
import { AdminDocumentUploadForm } from 'components/admin/document-library/AdminDocumentUploadForm';
import { mutate } from 'swr';
import { AdminDocumentEditForm } from 'components/admin/document-library/AdminDocumentEditForm';
import { DocumentData } from 'models/DocumentLibrary';

const DocumentUploadDialog: React.FC<{
    open: boolean;
    document?: DocumentData;
}> = (props) => {
    const pdfDialog = usePdfDialog();
    const { t } = useTranslation('documentLibrary', {
        keyPrefix: 'UPLOAD_DIALOG',
    });
    const handleClose = () => {
        pdfDialog.closeAllDialog();
    };

    const handleSuccess = () => {
        pdfDialog.setPdfUploadDialogClosedWithSuccess(true);
        pdfDialog.closeAllDialog();

        return new Promise((r) => setTimeout(r, 500)).then(() =>
            mutate((key) => true)
        );
    };

    return (
        <Dialog open={props.open} onClose={handleClose} fullWidth>
            <StyledDialogTitle>
                <StyledTitle>{t('TITLE')}</StyledTitle>
                <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
            </StyledDialogTitle>
            <StyledDialogContent>
                <AdminDocumentUploadForm submitSuccess={handleSuccess} />
            </StyledDialogContent>
        </Dialog>
    );
};

export default DocumentUploadDialog;
